import React from "react";
import Widget from "../../Widget/Widget";
import SettingsModal from "../../Modal/SettingsModal";
import NoteModal from "../WidgetsSettings/Note/NoteSettingsModal";

const NoteWidget = ({ value, role }) => {
   return (
      <Widget
         styleName="gx-m-0"
         bgColor={value.backgroundColourHex}
         title={value.noteTitle}
         role={role}
         extra={
            (role === "OWNER" || role === "MODERATOR") && (
               <SettingsModal
                  widgetName={value.name}
                  widgetId={value.id}
                  icon="setting"
                  deleteIcon="true"
                  children={<NoteModal value={value} />}
               />
            )
         }
      >
         <p>{value.content}</p>
      </Widget>
   );
};

export default NoteWidget;
